import React, { useRef } from "react";
import { message } from "antd";
import { useTechnicianModel } from "../technicianModel";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText } from "@/utils/utils"
import { ITechnicianFields } from "../technicianType";
import { DetailType } from "../../../../types/ScmEnums"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export function DetailDrawer() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { detailDrawer: visible, detailType, addFormVal, selectedRow, setDetailDrawer, insertDetail, editDetail, setSelectedRowKeys } = useTechnicianModel();
    const formRef = useRef<IYhFormRef>();

    const onCancel = () => {
        setDetailDrawer(false);
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            if (detailType == DetailType.add) {
                insertDetail(res).then(res => {
                    if (res) {
                        setSelectedRowKeys([res])
                        setDetailDrawer(false)
                    }
                }
                )
            } else if (detailType == DetailType.edit) {
                editDetail({ ...res, id: selectedRow[0].id }).then(res => res && setDetailDrawer(false))
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        formValues: detailType == DetailType.add ? addFormVal : selectedRow[0],
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "姓名",
                fieldLabel: Locale["Name"],
                fieldName: "name",
                span: 24,
                rules: [{ required: true, message: "请输入姓名" }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "手机号",
                fieldLabel: Locale["Phone"],
                fieldName: "phone",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "职务",
                fieldLabel: Locale["Post"],
                fieldName: "title",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "分配点数",
                fieldLabel: Locale["Assigned Points"],
                fieldName: "assignPoints",
                span: 24,
            }
        ]
    };
    return (
        <YHDrawer
            {...{
                title: `${detailType == DetailType.add ? Locale["New Technician"] : Locale["Edit Technician"]}`,
                visible,
                onCancel,
                okText: Locale["Save"],
                cancelText: Locale["Back"],
                onOk: onSubmit
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}
